import React, { ReactNode } from 'react';

import icon_alert from '../../../assets/img/common/icon_alert.svg';

const SearchAlert = ({children}:{children: ReactNode}) => {

    return (
        <div className="c-box c-box--alert" role="alert">
        <div className="c-box__icon"><svg width={24} height={30} aria-label="警告"><use href={`${icon_alert}#iconAlert`} /></svg></div>
        <div className="c-box__body">
            {children}
        </div>
        </div>
    );
};
export default SearchAlert;